// component default props:
import StyledBox from '@jswork/styled-box';
import styled from 'styled-components';

Object.assign(StyledBox.defaultProps, {
  styled,
  val: value => (parseInt(value, 10) / 16).toFixed(2),
  unit: 'rem',
  plugins: [
    require('@jswork/styled-plugin-absolute-center').default,
    require('@jswork/styled-plugin-em-justify-list').default,
    require('@jswork/styled-plugin-flexbox').default,
    require('@jswork/styled-plugin-radius-strip').default,
    require('@jswork/styled-plugin-scaleable-image').default,
    require('@jswork/styled-plugin-shadow').default,
    require('@jswork/styled-plugin-transform-center').default,
    require('@jswork/styled-plugin-line').default,
  ],
});
